class GiftingOptionsSwiperComponent extends HTMLElement {
  constructor() {
    super();
    this.swiper = new Swiper(this.querySelector(".mySwiper"), {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 40,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        1: {
          slidesPerView: 2,
          spaceBetween: 13,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    });
  }
}

customElements.define("gifting-option-swiper-component", GiftingOptionsSwiperComponent);

var swiper = new Swiper(".collections__swiper", {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 8,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 8,
      },
    },
});

var swiper = new Swiper(".similar__products-slider", {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 40, 
    breakpoints: {
      1: {
        spaceBetween: 13,
        slidesPerView: 2,
      },
      768: {
        spaceBetween: 20,
        slidesPerView: 3,
      },
      1024: {
        spaceBetween: 40,
        slidesPerView: 4,
      },
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// Cake List

var swiper = new Swiper(".list__thumb-slider", {
    direction: "vertical",
    spaceBetween: 22,
    slidesPerView: 7,
    breakpoints: {
      1: {
        slidesPerView: 'auto',
        spaceBetween: 29,
        direction: "horizontal",
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 29,
        direction: "horizontal",
      },
      1024: {
        direction: "vertical",
        spaceBetween: 22,
        slidesPerView: 7,
      },
    },
});
// var swiper = new Swiper(".similar__product-slide", {
//     spaceBetween: 40,
//     slidesPerView: 4,
//     breakpoints: {
//       1: {
//         spaceBetween: 13,
//         slidesPerView: 2,
//       },
//       768: {
//         spaceBetween: 20,
//         slidesPerView: 3,
//       },
//       1024: {
//         spaceBetween: 40,
//         slidesPerView: 4,
//       },
//     },
// });
var swiper2 = new Swiper(".list__single-slider", {
    spaceBetween: 10,
    thumbs: {
        swiper: swiper,
    },
});

// Creation Slider
var swiper = new Swiper(".creation__swiper", {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 7,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        1: {
          slidesPerView: 1,
          spaceBetween: 7,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 7,
        },
    },
});


// Single Product Image slider

var swiper = new Swiper(".gallery__thumb", {
    loop: true,
    spaceBetween: 8.81,
    slidesPerView: 6,
    direction: "vertical",
    breakpoints: {
      1: {
        slidesPerView: 'auto',
        spaceBetween: 5,
        direction: "horizontal",
      },
      768: {
        spaceBetween: 8.81,
        slidesPerView: 6,
        direction: "vertical",
      },
      1024: {
        spaceBetween: 8.81,
        slidesPerView: 6,
        direction: "vertical",
      },
    },
});
var swiper2 = new Swiper(".gallery__main", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
});

// Location
var swiper = new Swiper(".location__slider", {
    spaceBetween: 30,
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
});

// Faqs Slider
var swiper = new Swiper(".faqSlider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
});

// Class EventSwiper extends HTMLElement{
  
// }
// customElement.define('event-swiper', EventSwiper)
// var swiper = new Swiper(".events__slider", {
//   slidesPerView: 3,
//   spaceBetween: 34,
//   pagination: {
//     el: ".swiper-pagination",
//     clickable: true,
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     1: {
//       slidesPerView: 1,
//       spaceBetween: 15,
//     },
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 34,
//     },
//     1024: {
//       slidesPerView: 3,
//       spaceBetween: 15,
//     },
//     1100: {
//       slidesPerView: 3,
//       spaceBetween: 34,
//     },
//   },
// });

class EventSwiper extends HTMLElement{
  constructor(){
    super();
    this.init();

  }
  init(){
    if(Swiper){
      this.swiper = new Swiper(this.querySelector('.events__slider'), {
        slidesPerView: 3,
        spaceBetween: 34,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
        breakpoints: {
          1: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 34,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 34,
          },
        },
      })
      if(this.swiper){
        this.swiper.on('slideChange', this.SlideChange.bind(this));
        this.swiper.on('resize', this.SlideChange.bind(this));
        this.updateCustomNumber(this.swiper.activeIndex + 1, this.swiper.pagination.bullets.length)
      }
    }
  }
  SlideChange(swiper){
    this.updateCustomNumber(this.swiper.activeIndex + 1, this.swiper.pagination.bullets.length)
  }
  updateCustomNumber(current, total){
    let str = `${current}/${total}`;
    if(this.querySelector('.swiper__pagination-numbers p')){
      this.querySelector('.swiper__pagination-numbers p').innerText = str;
    }
  }
}
customElements.define('event-swiper', EventSwiper)



function openTab(tabName, btnElement) {
    var i, tabContent, tabButtons;

    tabContent = document.getElementsByClassName("tab-content");
    for (i = 0; i < tabContent.length; i++) {
        tabContent[i].style.display = "none";
    }

    tabButtons = document.getElementsByClassName("tab-button");
    for (i = 0; i < tabButtons.length; i++) {
        tabButtons[i].classList.remove("active");
    }

    document.getElementById(tabName).style.display = "block";
    btnElement.classList.add("active");
}

// Open the default tab on page load
document.getElementById("defaultOpen")?.click();



document.getElementById('close__filter')?.addEventListener('click', function() {
    document.body.classList.add('full__width');
});
document.getElementById('open__filter')?.addEventListener('click', function() {
    document.body.classList.remove('full__width');
});











